import { render, staticRenderFns } from "./emailTemplateOverview.vue?vue&type=template&id=5d4f6e08&"
import script from "./emailTemplateOverview.vue?vue&type=script&lang=js&"
export * from "./emailTemplateOverview.vue?vue&type=script&lang=js&"
import style0 from "./emailTemplateOverview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports